import React, {useContext} from 'react';
import {consumePath, NavigationContext} from "./Navigation";

export function NavigationConsumer({quantity = 1, children}) {
  const [navigation, consumedParams] = consumePath(useContext(NavigationContext), quantity);

  return <NavigationContext.Provider value={navigation}>
    {children(consumedParams)}
  </NavigationContext.Provider>
}